export default "__VITE_ASSET__BD9EZJ26__"